import { TableCell, TableHead, TableRow } from "@mui/material";
import { ReactComponent as EditIcon } from "assets/images/square-buttons/edit-line.svg";
import Tooltip from "components/Tooltip";

export const TableHeader = () => {
  return (
    <TableHead>
      <TableRow>
        <TableCell align="left" width={"20%"}>
          Date Time
        </TableCell>
        <TableCell align="left" width="20%">
          Instructor
        </TableCell>
        <TableCell align="left" width="20%">
          Category
        </TableCell>
        <TableCell align="left" width="20%">
          Details
        </TableCell>
        <TableCell align="right" width="20%">
          Actions
        </TableCell>
      </TableRow>
    </TableHead>
  );
};

export const TableItem = ({ data, onClickEdit }) => {
  return (
    <TableRow>
      <TableCell align="left" className="bold">
        {data.date}
      </TableCell>
      <TableCell align="left" className="bold black">
        {data.instructor}
      </TableCell>
      <TableCell align="left" className="bold">
        {data.type}
      </TableCell>
      <TableCell align="left" className="bold">
        {data.message}
      </TableCell>
      <TableCell align="right">
        <div className={"buttons-bar"}>
          <Tooltip content={"Edit"} direction="bottom">
            <button onClick={() => onClickEdit(data)}>
              <EditIcon />
            </button>
          </Tooltip>
        </div>
      </TableCell>
    </TableRow>
  );
};
